export default __webpack_public_path__ + "locales/sq-AL/PDFFormDialog.json?hash=1163133efdf133bc0141c0cd0f1a5426";